import React from "react";
import { newProfilePersonalInfoApplicationPath } from "../../../../../../routes";
import InfoFilledIcon from "../../icons/InfoFilledIcon";

import Button from "../../ui/Button";

import { Box, HStack, Link, Text } from "@chakra-ui/react";

export const ArchitectApplicationRevisionPrompt = () => (
  <Box backgroundColor="background.caution.light" px={5} py={4}>
    <HStack gap={3} align="center">
      <InfoFilledIcon boxSize={6} color="text.caution.dark" flexShrink={0} />
      <Text fontSize="xs">
        現在、
        <Text as="span" fontWeight="bold" color="text.caution.dark">
          申請内容に修正が必要
        </Text>
        なため審査が停止中です。プロフィール編集画面にて内容を確認の上、再申請してください。
      </Text>
    </HStack>
    <Button
      as={Link}
      textDecoration="none"
      variant="outline"
      w="full"
      mt={4}
      size="sm"
      href={newProfilePersonalInfoApplicationPath()}
    >
      修正項目を確認する
    </Button>
  </Box>
);
